module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-other_5.db4c6d68.png";